import fetchAPI from '../fetchAPI';

export const callSignOutAllNegotiatorUsers = async (): Promise<iResponse<any>> => {
  const response: iResponse<any> = await fetchAPI({
    method: 'POST',
    route: 'user/signout-all-negotiator'
  });
  return response;
};

export default callSignOutAllNegotiatorUsers;
